// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".over-flow[data-v-2549da78]{overflow:hidden}", ""]);
// Exports
module.exports = exports;
